import { Button, DropdownMenu } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { useComponentVisible } from 'hooks';
import { useStreamFileDownload } from 'hooks/useStreamFileDownload';
import { t } from 'i18next';
import { PiDownload } from 'react-icons/pi';
import {
  useGetLabelReportDetailedFile,
  useGetLabelReportDetailedFilePreview,
  useGetLabelReportFile,
  useGetLabelReportFilePreview,
} from 'services/label-report';

interface ILabelReportButtonDownloadProps {
  id: string;
  name: string;
  alignTop?: boolean;
  canGenerateDetailedReport?: boolean;
}

const LabelReportButtonDownload = ({
  id,
  name,
  alignTop,
  canGenerateDetailedReport = true,
}: ILabelReportButtonDownloadProps) => {
  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);
  const { setFile: setSimpleFile } = useStreamFileDownload(useGetLabelReportFile);
  const { setFile: setDetailedFile } = useStreamFileDownload(
    useGetLabelReportDetailedFile
  );

  if (!canGenerateDetailedReport) {
    return (
      <MagellanPopups.FilePreviewPopup
        fileId={id}
        fileName={name}
        fileService={useGetLabelReportFilePreview}
        trigger={
          <Button isClear onlyIcon>
            <Button.Description description={t('button.download')} />
            <Button.Icon icon={<PiDownload />} />
          </Button>
        }
        onDownload={() => setSimpleFile({ id, name })}
      />
    );
  }

  return (
    <Button
      isClear
      onlyIcon
      onClick={handleComponentVisible}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          style={{ padding: 0 }}
          align={alignTop ? 'top' : 'bottom'}
          justifyPosition='end'>
          <MagellanPopups.FilePreviewPopup
            fileId={id}
            fileName={`${name}_${t('button.simple')}`}
            fileService={useGetLabelReportFilePreview}
            trigger={
              <Button type='button' isClear fullWidth size='compact'>
                <Button.Icon icon={<PiDownload />} />
                <Button.Text text={t('button.simple')} />
              </Button>
            }
            onDownload={() =>
              setSimpleFile({ id, name: `${name}_${t('button.simple')}` })
            }
          />
          <MagellanPopups.FilePreviewPopup
            fileId={id}
            fileName={`${name}_${t('button.detail')}`}
            fileService={useGetLabelReportDetailedFilePreview}
            trigger={
              <Button
                type='button'
                isClear
                fullWidth
                size='compact'
                buttonStyle={{ justifyContent: 'start' }}>
                <Button.Icon icon={<PiDownload />} />
                <Button.Text text={t('button.detail')} />
              </Button>
            }
            onDownload={() =>
              setDetailedFile({ id, name: `${name}_${t('button.detail')}` })
            }
          />
        </DropdownMenu>
      }>
      <Button.Description description={t('button.download')} />
      <Button.Icon icon={<PiDownload />} />
    </Button>
  );
};

export default LabelReportButtonDownload;
